import Swiper from "swiper/bundle";
import Plyr from 'plyr';

(function ($) {

    //swiper
    let swiper = new Swiper(".section-testimonials .slider-testimonials", {
        slidesPerView: "auto",
        spaceBetween: 8,
        centeredSlides: false,
        watchSlidesProgress: true,
        watchSlidesVisibility: true,
        navigation: {
            nextEl: ".section-testimonials .swiper-button-next",
            prevEl: ".section-testimonials .swiper-button-prev",
        },
        pagination: {
            el: ".section-testimonials .swiper-pagination",
            clickable: true,
        }
    });

    //popup
    $(document).ready(function () {
        const modal = $("#videoModal2");
        const videoElement = modal.find("video");
        const player = new Plyr("#player2", {
            fullscreen: { enabled: false }
        });

        player.elements.container.addEventListener("dblclick", (event) => {
            event.stopPropagation();
            event.preventDefault();
        });

        //touch devices
        let lastTap = 0;
        player.elements.container.addEventListener("touchend", (event) => {
            const currentTime = new Date().getTime();
            const tapLength = currentTime - lastTap;

            if (tapLength < 300 && tapLength > 0) {
                event.stopPropagation();
            }

            lastTap = currentTime;
        });

        // insert URL video
        $(".section-testimonials .wrap-video").on("click", function () {
            const videoUrl = $(this).data("video");
            videoElement.attr("src", videoUrl);
        });

        // play video
        modal.on("shown.bs.modal", function () {
            player.play();
        });

        // clear URL video & pause
        modal.on("hidden.bs.modal", function () {
            player.pause();
            videoElement.attr("src", "");
        });
    });


//play video preview on hover
    $(document).ready(function() {
        const isTouchDevice = "ontouchstart" in window || navigator.maxTouchPoints > 0;

        $(".section-testimonials .wrap-video video").each(function() {
            const $video = $(this);

            if (isTouchDevice) {
                //$video.removeAttr('autoplay');
            } else {
                $video.removeAttr("autoplay");
                const $wrapVideo = $video.closest(".wrap-video");

                $wrapVideo.on("mouseenter", function() {
                    $video.get(0).play();
                });

                $wrapVideo.on("mouseleave", function() {
                    $video.get(0).pause();
                    //$video.get(0).currentTime = 0; //start video from 0
                });
            }
        });
    });


})(jQuery);